import ClassLists from '@/shared/publish/MyPublications/ClassLists'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/publish/MyPublications/ClassLists/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ClassLists />
}
